import { Component } from '@theme/component';

/** Approved VamsLuna homepage: live product data, sequential banners, and local UI. */
class VamsLunaRedHome extends Component {
  #perspectivesCleanup;
  #abort;
  #resize;
  #timer;
  #frame;
  #cleanup() {
    this.#perspectivesCleanup?.();
    this.#perspectivesCleanup = undefined;
    this.#abort?.abort();
    this.#resize?.disconnect();
    clearInterval(this.#timer);
    cancelAnimationFrame(this.#frame);
  }
  connectedCallback() { super.connectedCallback(); this.#setup(); }
  updatedCallback() { super.updatedCallback(); this.#setup(); }
  disconnectedCallback() { super.disconnectedCallback(); this.#cleanup(); }
  #setup() {
    this.#cleanup();
    this.#abort = new AbortController();
    const signal = this.#abort.signal;
    const on = (target, name, handler, options = {}) => target?.addEventListener(name, handler, { ...options, signal });
    const $ = selector => this.querySelector(selector);
    const $$ = selector => [...this.querySelectorAll(selector)];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const ui = JSON.parse($('[data-home-ui]').textContent);
    const routines = JSON.parse($('[data-home-routines]').textContent);
    const products = $$('[data-product-json]').map(node => JSON.parse(node.textContent));
    const cards = $$('[data-card]');
    const shelf = $('#products');
    const filters = $$('[data-filter]');
    const html = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    function updateShelf() {
      const max = shelf.scrollWidth - shelf.clientWidth;
      $('#shelf-prev').disabled = shelf.scrollLeft < 3;
      $('#shelf-next').disabled = shelf.scrollLeft >= max - 3;
    }
    const selectCategory = category => {
      const list = products.filter(p => category === 'all' || p.category === category);
      cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
      shelf.classList.toggle('filtered', category !== 'all');
      shelf.scrollLeft = 0;
      filters.forEach(button => {
        const selected = button.dataset.filter === category;
        button.id = 'filter-' + button.dataset.filter;
        button.setAttribute('aria-controls', 'products');
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      shelf.setAttribute('aria-labelledby', 'filter-' + category);
      $('#product-count').textContent = list.length === 1 ? ui.one_product : ui.many_products.replace('__COUNT__', list.length);
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(updateShelf);
    };
    filters.forEach(button => on(button, 'click', () => selectCategory(button.dataset.filter)));
    on($('.product-filters'), 'keydown', event => {
      let index = filters.indexOf(document.activeElement);
      if (index < 0) return;
      if (event.key === 'ArrowRight') index = (index + 1) % filters.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + filters.length) % filters.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = filters.length - 1;
      else return;
      event.preventDefault(); selectCategory(filters[index].dataset.filter); filters[index].focus();
    });
    on(this, 'click', event => {
      const link = event.target.closest('[data-shop-category]');
      if (!link) return;
      event.preventDefault(); selectCategory(link.dataset.shopCategory);
      $('#featured').scrollIntoView({behavior: reduced.matches ? 'instant' : 'smooth'});
    });
    for (const [id, direction] of [['shelf-prev', -1], ['shelf-next', 1]]) {
      on($('#' + id), 'click', () => {
        const card = cards.find(card => !card.hidden);
        shelf.scrollBy({left: ((card?.getBoundingClientRect().width || 200) + parseFloat(getComputedStyle(shelf).gap)) * direction, behavior: reduced.matches ? 'instant' : 'smooth'});
      });
    }
    on(shelf, 'scroll', updateShelf, {passive: true});
    this.#resize = new ResizeObserver(updateShelf); this.#resize.observe(shelf);
    const slides = $$('[data-slide]'), dots = $$('[data-go-slide]'), hero = $('.hero');
    let slideIndex = 0;
    const showSlide = index => {
      slideIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== slideIndex; slide.classList.toggle('active', i === slideIndex); });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === slideIndex)));
    };
    const scheduleHero = () => {
      clearInterval(this.#timer);
      if (!document.hidden) this.#timer = setInterval(() => showSlide(slideIndex + 1), Number(this.dataset.interval) || 7000);
    };
    dots.forEach(dot => on(dot, 'click', () => { showSlide(Number(dot.dataset.goSlide)); scheduleHero(); }));
    on($('#hero-prev'), 'click', () => { showSlide(slideIndex - 1); scheduleHero(); });
    on($('#hero-next'), 'click', () => { showSlide(slideIndex + 1); scheduleHero(); });
    on(document, 'visibilitychange', scheduleHero);
    let touchX = 0, touchY = 0;
    on(hero, 'touchstart', e => { touchX = e.changedTouches[0].clientX; touchY = e.changedTouches[0].clientY; }, {passive: true});
    on(hero, 'touchend', e => {
      const x = e.changedTouches[0].clientX - touchX, y = e.changedTouches[0].clientY - touchY;
      if (Math.abs(x) > 65 && Math.abs(x) > Math.abs(y)) { showSlide(slideIndex + (x < 0 ? 1 : -1)); scheduleHero(); }
    }, {passive: true});
    const quick = $('#quick-view'); let returnFocus;
    $$('[data-quick]').forEach(button => { button.hidden = false; });
    on(shelf, 'click', event => {
      const button = event.target.closest('[data-quick]'); if (!button) return;
      const product = products.find(p => p.id === button.dataset.quick); if (!product) return;
      returnFocus = button;
      $('#quick-title').textContent = product.title; $('#quick-category').textContent = product.categoryLabel;
      $('#quick-price').textContent = product.price; $('#quick-description').textContent = product.description;
      $('#quick-image').src = product.image; $('#quick-image').alt = product.title; $('#quick-link').href = product.url;
      quick.showModal();
    });
    $$('dialog').forEach(dialog => {
      on(dialog.querySelector('.dialog-close'), 'click', () => dialog.close());
      on(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      on(dialog, 'close', () => returnFocus?.focus());
    });
    const search = $('#search-dialog'), input = $('#search-input');
    const renderSearch = () => {
      const query = input.value.toLowerCase().trim();
      const list = products.filter(p => (p.title + ' ' + p.categoryLabel).toLowerCase().includes(query));
      $('#search-results').innerHTML = list.length ? list.map(p => `<a class="search-result" href="${html(p.url)}"><img src="${html(p.image)}" alt="" width="65" height="65"><div><strong>${html(p.title)}</strong><span>${html(p.price)}</span></div></a>`).join('') : `<p class="empty-result">${html(ui.no_products)}</p>`;
    };
    on($('#open-search'), 'click', event => { returnFocus = event.currentTarget; renderSearch(); search.showModal(); input.focus(); });
    on(input, 'input', renderSearch);
    const menu = $('.menu-toggle'), nav = $('#main-nav');
    const closeMenu = () => { nav.classList.remove('open'); menu.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-label', ui.open_menu); };
    on(menu, 'click', () => { const opened = nav.classList.toggle('open'); menu.setAttribute('aria-expanded', String(opened)); menu.setAttribute('aria-label', opened ? ui.close_menu : ui.open_menu); });
    on(nav, 'click', e => { if (e.target.closest('a')) closeMenu(); });
    on(document, 'keydown', e => { if (e.key === 'Escape') closeMenu(); });
    $$('[data-routine]').forEach(button => on(button, 'click', () => {
      $$('[data-routine]').forEach(b => { b.classList.toggle('active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
      const key = button.dataset.routine, data = routines[key];
      $('#routine-title').textContent = data.title; $('#routine-text').textContent = data.text;
      const link = $('#routine-link'); link.textContent = data.label + ' ↗'; link.dataset.shopCategory = key;
      link.href = $('[data-shop-category="' + key + '"]').href;
    }));
    const back = $('.back-top');
    on(window, 'scroll', () => back.classList.toggle('show', scrollY > 700), {passive: true});
    on(back, 'click', () => window.scrollTo({top: 0, behavior: reduced.matches ? 'instant' : 'smooth'}));
    this.#perspectivesCleanup = initPerspectiveRail(this);
    selectCategory('all'); showSlide(0); scheduleHero();
  }
}
if (!customElements.get('vl-red-home-component')) customElements.define('vl-red-home-component', VamsLunaRedHome);

// Fictional opinion rail; does not create or imply real endorsements.
function initPerspectiveRail(root) {
  const abort = new AbortController();
  const on = (target, name, handler, options = {}) => target?.addEventListener(name, handler, { ...options, signal: abort.signal });
  const track = root.querySelector('#perspective-track');
  if (!track) return () => {};
  const cards = [...track.querySelectorAll('.perspective-card')];
  const position = root.querySelector('#perspective-position');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let timer, visible = false, frame;
  const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
  const offset = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  const stops = () => [...new Set([0, ...cards.map(card => Math.round(Math.min(maxScroll(), Math.max(0, offset(card))))), maxScroll()])].sort((a,b) => a-b).filter((x,i,a) => i===0 || x-a[i-1]>3);
  function updatePosition() {
    const bounds = track.getBoundingClientRect();
    const shown = cards.map((card,index) => ({index,rect:card.getBoundingClientRect()})).filter(({rect}) => Math.min(rect.right,bounds.right)-Math.max(rect.left,bounds.left) > rect.width*.5);
    if(shown.length) {
      const first=shown[0].index+1,last=shown[shown.length-1].index+1;
      position.textContent=position.dataset.positionTemplate.replace('__RANGE__', first===last ? String(first) : first+'–'+last).replace('__TOTAL__', String(cards.length));
    }
  }
  function move(direction) {
    const points = stops();
    if(points.length < 2) return;
    const current = Math.max(0,Math.min(maxScroll(),track.scrollLeft));
    const target = direction>0 ? points.find(point=>point>current+3) ?? points[0] : points.slice().reverse().find(point=>point<current-3) ?? points[points.length-1];
    track.scrollTo({left:target,behavior:motion.matches?'instant':'smooth'});
  }
  function schedule() {
    clearInterval(timer);
    if(visible && !document.hidden && !motion.matches && maxScroll()>3) timer=setInterval(()=>move(1),7000);
  }
  for(const [id,direction] of [['perspective-prev',-1],['perspective-next',1]]) on(root.querySelector('#'+id), 'click',()=>{move(direction);schedule();});
  on(track, 'scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(updatePosition);},{passive:true});
  on(track, 'pointerdown',schedule,{passive:true});
  on(track, 'keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);schedule();}
    else if(event.key==='Home'||event.key==='End'){event.preventDefault();track.scrollTo({left:event.key==='Home'?0:maxScroll(),behavior:motion.matches?'instant':'smooth'});schedule();}
  });
  const intersection = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.2});
  intersection.observe(track);
  const resize = new ResizeObserver(()=>{updatePosition();schedule();});
  resize.observe(track);
  on(document, 'visibilitychange',schedule);
  on(motion, 'change',schedule);
  on(window, 'pagehide',()=>{clearInterval(timer);cancelAnimationFrame(frame);});
  on(window, 'pageshow',schedule);
  updatePosition();
  return () => { abort.abort(); intersection.disconnect(); resize.disconnect(); clearInterval(timer); cancelAnimationFrame(frame); };
}
